module.exports = __webpack_public_path__ + "media/04.9b1aa22a.mp4";